var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arrow",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.481,
    height: 24.481,
    viewBox: "0 0 24.481 24.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transfer_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MingCute",
    d: "M24.481,0V24.481H0V0ZM12.846,23.724l-.012,0-.072.036-.019,0h0l-.016,0-.072-.036a.022.022,0,0,0-.024.006l0,.011-.017.436.005.021.011.012.106.075.015,0h0l.012,0,.106-.075.013-.016h0l0-.017-.017-.436a.022.022,0,0,0-.016-.018Zm.27-.115-.014,0-.188.094-.01.01h0l0,.011.018.438,0,.013h0l.009.007.2.095a.026.026,0,0,0,.029-.008l0-.014-.035-.627a.026.026,0,0,0-.02-.022Zm-.73,0a.023.023,0,0,0-.028.005l-.006.014-.035.627a.023.023,0,0,0,.017.024h.016l.2-.095.01-.008h0l0-.012.018-.438,0-.013h0l-.01-.009Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M20.351,14.221a1.53,1.53,0,0,1,.147,3.053l-.147.007H7.724l1.468,1.468a1.53,1.53,0,0,1-2.048,2.269l-.116-.105L3.122,17.007a1.632,1.632,0,0,1,1.011-2.78l.143-.006ZM15.189,3.448a1.53,1.53,0,0,1,2.048-.105l.116.105,3.906,3.906a1.632,1.632,0,0,1-1.011,2.78l-.143.006H4.03a1.53,1.53,0,0,1-.147-3.053L4.03,7.08H16.657L15.189,5.612A1.53,1.53,0,0,1,15.189,3.448Z",
    transform: "translate(0.05 0.06)",
    fill: "#165cf3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationBlueIcon);
export default __webpack_public_path__ + "static/media/integration-blue-icon.e199707cba4b954de713ef9d94a07d32.svg";
export { ForwardRef as ReactComponent };